// Generated by ReScript, PLEASE EDIT WITH CARE


var navClassName = "mr-96 sm:mr-0 border-transparent border-b text-sm lg:text-sm w-auto";

var activeClassName = "border-black cursor-default " + navClassName + "";

var inactiveClassName = "hover:border-gray-700 sm:hover:text-gray-800 " + navClassName + "";

var padding = "p-5";

var h1ClassName = "ring-black ring-opacity-5 bg-white text-3xl font-bold text-gray-900 " + padding + "";

var navItemClassName = "hover:text-gray-700 hover:border-gray-300 text-sm border-b2";

var divideClassName = "divide-y divide-gray-200";

var h2ClassName = "text-lg leading-6 font-medium text-gray-900 flex-grow";

var liPrimaryClassName = "";

var liSecondaryClassName = "text-gray-500";

var clickableClassName = "block hover:bg-gray-50";

export {
  navItemClassName ,
  navClassName ,
  activeClassName ,
  inactiveClassName ,
  divideClassName ,
  padding ,
  h1ClassName ,
  h2ClassName ,
  liPrimaryClassName ,
  liSecondaryClassName ,
  clickableClassName ,
}
/* No side effect */
